module.exports = __webpack_public_path__ + "img/inst.8d36d49.png";